import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityReference } from '../../entities/shared/entity-reference.entity';
import { PaginatedResult } from '../../entities/shared/paginated-result.entity';
import { AbstractHttpService } from '../../services/abstract-http.service';
import { PurchaseBase } from './entities/purchase-base.entity';
import { Purchase } from './entities/purchase.entity';
import { PaginatedPurchaseQuery, PurchaseQuery } from './queries/purchase.query';

@Injectable({
  providedIn: 'root',
})
export class PurchasesApi extends AbstractHttpService {
  endpoint = 'purchases';

  create(data: PurchaseBase): Observable<Purchase> {
    return this.post<PurchaseBase, Purchase>(data);
  }

  findAll(query: PaginatedPurchaseQuery): Observable<PaginatedResult<Purchase>> {
    return this.get<PaginatedResult<Purchase>>({ query });
  }

  findAllCompact(query?: PurchaseQuery): Observable<EntityReference[]> {
    return this.get<EntityReference[]>({ path: 'compact', query });
  }

  findOne(id: number): Observable<Purchase> {
    return this.get<Purchase>({ path: id });
  }

  update(id: number, data: PurchaseBase): Observable<Purchase> {
    return this.patch<PurchaseBase, Purchase>(data, { path: id });
  }

  deleteOne(id: number): Observable<Purchase> {
    return this.delete<Purchase>({ path: id });
  }
}
